import { render } from "./newCommentForm.vue?vue&type=template&id=e942e5de&scoped=true&ts=true"
import script from "./newCommentForm.vue?vue&type=script&lang=ts"
export * from "./newCommentForm.vue?vue&type=script&lang=ts"

import "./newCommentForm.vue?vue&type=style&index=0&id=e942e5de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e942e5de"]])

export default __exports__